'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import { getDefaultRegistry } from '../../utils/defaults';
import { getDefaultValue } from '../../utils/additionalPropertyUtils';
import CollapseFieldWrapper from './shared/CollapseFieldWrapper';
import NumberInput from '../inputs/NumberInput';
import { jsx as _jsx } from "react/jsx-runtime";
export default class NumberField extends Component {
  constructor(...args) {
    super(...args);
    this.getPlaceholder = () => {
      const {
        isAdditionalProperty,
        placeholder
      } = this.props;
      if (placeholder !== undefined) {
        return placeholder;
      }
      if (isAdditionalProperty) {
        return getDefaultValue('number');
      }
      return null;
    };
  }
  getFieldRestrictions() {
    const {
      schema
    } = this.props;
    const restrictions = {
      increment: 1,
      min: null,
      max: null
    };
    if (schema.multipleOf) {
      restrictions.increment = schema.multipleOf;
    }
    if (!isNaN(schema.minimum)) {
      restrictions.min = schema.minimum;
    }
    if (!isNaN(schema.maximum)) {
      restrictions.max = schema.maximum;
    }
    return restrictions;
  }
  render() {
    const {
      autoFocus,
      collapsed,
      disabled,
      formData,
      idSchema,
      isAdditionalProperty,
      name,
      onChange,
      readOnly,
      registry,
      required,
      schema
    } = this.props;
    const {
      title,
      format
    } = schema;
    const {
      formContext
    } = registry;
    return /*#__PURE__*/_jsx(CollapseFieldWrapper, {
      collapsed: collapsed,
      formData: formData,
      isAdditionalProperty: isAdditionalProperty,
      children: /*#__PURE__*/_jsx(NumberInput, Object.assign({
        autoFocus: autoFocus,
        format: format,
        formContext: formContext,
        id: idSchema && idSchema.$id,
        increment: 1,
        disabled: disabled,
        label: title || name,
        onChange: onChange,
        placeholder: this.getPlaceholder(),
        readOnly: readOnly,
        required: required,
        schema: schema,
        value: formData
      }, this.getFieldRestrictions()))
    });
  }
}
NumberField.propTypes = {
  autoFocus: PropTypes.bool,
  collapsed: PropTypes.bool,
  disabled: PropTypes.bool,
  formData: PropTypes.any,
  idSchema: PropTypes.object,
  isAdditionalProperty: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  registry: PropTypes.object,
  required: PropTypes.bool,
  schema: PropTypes.object
};
NumberField.defaultProps = {
  disabled: false,
  readOnly: false,
  registry: getDefaultRegistry()
};